import { Directive, HostListener, Input, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: 'img[appDefaultImage]',
})
export class DefaultImageDirective {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('appDefaultImage') defaultImg: string;

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2) {
  }

  @HostListener('error')
  onError() {
    this.renderer.setAttribute(this.elementRef.nativeElement, 'src', this.defaultImg);
    //Remove srcset attribute if existed to prevent infinite loop
    this.renderer.removeAttribute(this.elementRef.nativeElement, 'srcset');
  }
}
